import col from './bf-col.vue';
col.install = Vue => Vue.component(col.name,col);
export default col;



// WEBPACK FOOTER //
// ./src/packages/grid/col/index.js